import React from 'react';
import { CustomTableToolbarSelect } from 'hooks/multipleSelection';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import { When } from 'UI/components/atoms/When';
import FPButtonMenu from 'UI/components/molecules/FPButtonMenu';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { SvgDeleteFilled, SvgDriveFileMoveRounded, SvgRestorePageRounded } from 'UI/res';
import { hasFeatureFlag } from 'UI/utils';

const setPrimaryColor = ({ primary }) => primary.main;
const { toolbar: toolbarCopies } = strings.searchProjects.mainPage.dataTable;

const CustomSearchProjectsIntoFoldersToolbar = ({
  actions,
  totalSelected,
  isArchivedTreeSelected
}) => {
  const moveSearchProjectsMenuItems = [
    {
      title: toolbarCopies.moveItemsMenuButton.menuItems.moveToExisting,
      action: actions.onOpenFolderDrawer({ moveToExistingFolder: true, open: true }),
      visible: true
    },
    {
      title: toolbarCopies.moveItemsMenuButton.menuItems.moveToNew,
      action: actions.onOpenFolderDrawer({ moveToNewFolder: true, open: true }),
      visible: true
    }
  ];

  return (
    <CustomTableToolbarSelect total={totalSelected}>
      {isArchivedTreeSelected ? (
        <FPIconButton
          icon={SvgRestorePageRounded}
          iconProps={{
            onSetColor: setPrimaryColor
          }}
          onClick={actions.onOpenRestoreInterface({ open: true })}
          tooltipProps={{ placement: 'bottom', title: toolbarCopies.restoreMultipleButton.title }}
        />
      ) : (
        <>
          <FPButtonMenu
            menuItems={moveSearchProjectsMenuItems}
            title={toolbarCopies.moveItemsMenuButton.title}
            isIconButton
            icon={SvgDriveFileMoveRounded}
            IconButtonProps={{
              iconProps: {
                onSetColor: setPrimaryColor
              }
            }}
          />
          <When condition={hasFeatureFlag(FeatureFlags.SearchProjectsArchiveMultiple)}>
            <FPIconButton
              icon={SvgDeleteFilled}
              iconProps={{
                onSetColor: setPrimaryColor
              }}
              onClick={actions.onOpenArchiveDialog({ open: true })}
              tooltipProps={{
                placement: 'bottom',
                title: toolbarCopies.archiveMultipleButton.title
              }}
            />
          </When>
        </>
      )}
    </CustomTableToolbarSelect>
  );
};

export default CustomSearchProjectsIntoFoldersToolbar;
